import { Select } from "antd";
import React, { useState } from "react";
import trans from "../../utils";
import DynamicDropdownField from "../FormBuilder/DynamicDropdownField";

export default function DropdownInput({
	id,
	item,
	preview,
	addData,
	submitData,
	setSubmitData,
	readOnly,
	value: controlledValue,
	onValueChange,
	scopeValues,
	includeProperties = [],
}) {
	const isMulti = item?.name === "MultiSelect";
	const [value, setValue] = useState(isMulti ? [] : null);
	const isControlled = typeof onValueChange === "function";
	const rawValue = isControlled
		? controlledValue
		: addData
		? submitData?.find((i) => i.key === item.key)?.value
		: submitData?.find((i) => i.key === item.key)?.value ?? item?.value ?? value;
	const currentValue = isMulti
		? Array.isArray(rawValue)
			? rawValue
			: rawValue === undefined
			? []
			: [rawValue]
		: rawValue ?? undefined;

	const isEmpty = isMulti
		? !Array.isArray(currentValue) || currentValue.length === 0
		: currentValue === undefined;
	const validate = addData
		? addData?.touched?.fields?.[item?.key]?.value && item?.required?.value && isEmpty
		: item?.required?.value && isEmpty;
	const styleValidate = addData
		? addData?.touched?.fields?.[item?.key]?.value && item?.required?.value && isEmpty
		: preview !== true && isEmpty && item?.required?.value;

	// Check if this is a dynamic dropdown
	const isDynamic =
		item?.dropdownOptions?.queryKey === "dynamic" ||
		!!item?.dropdownOptions?.entityConfig?.entityKey;

	const updateSubmitData = (newValue) => {
		if (isControlled) onValueChange(item.key, newValue);
		if (setSubmitData) {
			setSubmitData((prev) => {
				const filtered = prev?.filter((i) => i.key !== item.key) || [];
				return [
					...filtered,
					{
						key: item.key,
						name: item.name,
						title: item.title,
						value: newValue,
					},
				];
			});
		}
		if (addData) {
			addData.setFieldTouched(`fields[${item.key}].value`, true);
		}
	};

	return (
		<div style={item?.css}>
			<label
				htmlFor={id}
				className="form-label d-flex align-items-center"
				style={{
					color: item?.css?.color,
					fontFamily: item?.css?.fontFamily,
					fontSize: item?.css?.fontSize,
					fontWeight: item?.css?.fontWeight,
				}}
			>
				<div>{item?.title}</div>
				{item?.required?.value && isEmpty && (
					<div className="text-danger ms-2">*</div>
				)}
			</label>

			{isDynamic ? (
				<DynamicDropdownField
					field={item}
					value={currentValue}
					disabled={readOnly}
					placeholder={item?.placeholder}
						submitData={submitData}
						scopeValues={scopeValues}
						includeProperties={includeProperties}
					multiple={isMulti}
					onChange={(newValue) => {
						setValue(newValue);
						updateSubmitData(newValue);
					}}
				/>
			) : (
				<Select
					mode={isMulti ? "multiple" : undefined}
					allowClear={!readOnly}
					style={{
						width: "100%",
					}}
					status={styleValidate ? "error" : ""}
					placeholder={item?.placeholder}
					options={item?.dropdownOptions?.data}
					value={currentValue}
					disabled={readOnly}
					onChange={(e) => {
						const newValue = e;
						setValue(newValue);
						updateSubmitData(newValue);
					}}
					onBlur={() => {
						if (addData) {
							addData.setFieldTouched(`fields[${item?.key}].value`, true);
						}
					}}
				/>
			)}
			{preview !== true ? (
				<>
					{validate && (
						<div className="text-danger mt-1">
							{trans(item?.required?.validationMessage)}
						</div>
					)}
				</>
			) : (
				""
			)}
		</div>
	);
}
